(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (() => {
    const initCarousel = (section) => {
      const track = section.querySelector('[data-section-carousel-track]');
      if (!(track instanceof HTMLElement)) return;

      const columnCards = Array.from(track.children).filter(
        (node) => node instanceof HTMLElement && node.classList.contains('group-block')
      );
      const isRowLayout = track.classList.contains('layout-panel-flex--row');
      const carouselThreshold = Number.parseInt(section.dataset.carouselThreshold || '3', 10);
      const shouldEnable = isRowLayout && columnCards.length > carouselThreshold;

      if (!shouldEnable) return;

      section.classList.add('section--multicolumn-carousel');
      track.classList.add('section-content-wrapper--carousel');

      if (track.dataset.carouselReady === 'true') return;

      const previousButton = section.querySelector('[data-section-carousel-prev]');
      const nextButton = section.querySelector('[data-section-carousel-next]');
      if (!(previousButton instanceof HTMLButtonElement) || !(nextButton instanceof HTMLButtonElement)) return;

      track.dataset.carouselReady = 'true';

      const getStep = () => {
        const card = columnCards[0];
        if (!(card instanceof HTMLElement)) return track.clientWidth;
        const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
        return card.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        const maxScrollLeft = track.scrollWidth - track.clientWidth;
        previousButton.disabled = track.scrollLeft <= 4;
        nextButton.disabled = track.scrollLeft >= maxScrollLeft - 4;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateButtons, { passive: true });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateButtons);
        resizeObserver.observe(track);
      }

      updateButtons();
    };

    const initAll = () => {
      document.querySelectorAll('[data-testid="ui-test-section"]').forEach((section) => {
        if (section instanceof HTMLElement) initCarousel(section);
      });
    };

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
